import { SKIP_TRACING_TYPES } from '@cp/pages/CaseDetails/feedbackForm/constants';

export const genAiBotInteraction = 'GEN_AI_BOT';

export enum CALL_INTERACTIONS_TYPE {
  CALL_BRIDGE = 'CALL_BRIDGE',
  SELF_CALL = 'SELF_CALL',
  AMEYO = 'AMEYO',
  HUMAN_REMINDER = 'HUMAN_REMINDER',
  WHATSAPP_CALL = 'WHATSAPP_CALL',
  WHATSAPP_TEXT = 'WHATSAPP_TEXT',
  SKIP_TRACING_TELE = 'SKIP_TRACING_TELE',
  INBOUND_CALL = 'INBOUND_CALL',
  BOT_REMINDER = 'BOT_REMINDER',
  VENDOR_POC = 'VENDOR_POC'
}

export const feedbackTypes = [
  { label: 'Ameyo', value: CALL_INTERACTIONS_TYPE.AMEYO },
  { label: 'Slash', value: CALL_INTERACTIONS_TYPE.CALL_BRIDGE },
  { label: 'Self Call', value: CALL_INTERACTIONS_TYPE.SELF_CALL },
  { label: 'Whatsapp Call', value: CALL_INTERACTIONS_TYPE.WHATSAPP_CALL },
  { label: 'Whatsapp Text', value: CALL_INTERACTIONS_TYPE.WHATSAPP_TEXT },
  { label: 'Reminder', value: CALL_INTERACTIONS_TYPE.HUMAN_REMINDER },
  { label: 'Customer Outreach', value: CALL_INTERACTIONS_TYPE.SKIP_TRACING_TELE },
  { label: 'Reminder chat', value: genAiBotInteraction },
  { label: 'Inbound Call', value: CALL_INTERACTIONS_TYPE.INBOUND_CALL },
  { label: 'Customer Outreach - call', value: SKIP_TRACING_TYPES.SKIP_TRACING_CALL },
  { label: 'Customer Outreach - text', value: SKIP_TRACING_TYPES.SKIP_TRACING_TEXT },
  { label: 'Customer Outreach - others', value: SKIP_TRACING_TYPES.SKIP_TRACING_OTHERS },
  { label: 'Automated Reminder', value: CALL_INTERACTIONS_TYPE.BOT_REMINDER },
  { label: 'Vendor POC', value: CALL_INTERACTIONS_TYPE.VENDOR_POC }
];

export const FeedbackTypeFilterName = 'Type';

export const defaultFeedbackTypes = `${CALL_INTERACTIONS_TYPE.SELF_CALL},${CALL_INTERACTIONS_TYPE.CALL_BRIDGE},${CALL_INTERACTIONS_TYPE.INBOUND_CALL},${CALL_INTERACTIONS_TYPE.AMEYO},${CALL_INTERACTIONS_TYPE.HUMAN_REMINDER},${CALL_INTERACTIONS_TYPE.WHATSAPP_TEXT},${CALL_INTERACTIONS_TYPE.SKIP_TRACING_TELE},${genAiBotInteraction},${SKIP_TRACING_TYPES.SKIP_TRACING_OTHERS},${SKIP_TRACING_TYPES.SKIP_TRACING_CALL},${SKIP_TRACING_TYPES.SKIP_TRACING_TEXT},${CALL_INTERACTIONS_TYPE.BOT_REMINDER},${CALL_INTERACTIONS_TYPE.VENDOR_POC},${CALL_INTERACTIONS_TYPE.WHATSAPP_CALL}`;

export const RECORDING_ROW_HEIGHT = 80;

export const DPD_BUCKET_30 = 30;

export const LDN = 'Legal demand notice';
export const LRN = 'Loan recall notice';
export const TOOLTIP_LDN = 'Legal demand notice (LDN)';
export const TOOLTIP_LRN = 'Loan recall notice (LRN)';
export const DUNNING_LETTER = 'Dunning Letter';
export const LDN_NAME = 'Legal_Demand_Notice';
export const LRN_NAME = 'Loan_Recall_Notice';
export const DUNNING_LETTER_NAME = 'Dunning_Letter';
export const defaultPreviousLoanInteractionsFromDateString = '2020-01-01';
export const ADD_TIME = 'T00:00';
